/**
 * Memulihkan daftar TERPAGINASI SERVER setelah Kembali (memori posisi daftar,
 * `adminListMemory.ts`). Daftar seperti Produk / Pelanggan / Stok admin dan
 * katalog publik hanya memegang halaman yang sudah tergulir di state React;
 * Kembali me-mount ulang dari halaman pertama, sehingga kartu jangkar di
 * halaman ke-6 tak pernah dirender lagi. Memori daftar mengingat JUMLAH baris
 * yang sudah termuat; muatan pertama sesudah pulih mengambil ulang baris
 * 0..N-1 sekaligus.
 *
 * Plafon `LIST_RESTORE_MAX_PAGES` menjaga satu permintaan tetap wajar (200
 * baris untuk halaman 20 — jauh di bawah `max-rows` 1.000 PostgREST, dan 200
 * uuid ≈ 8 KB di bawah batas query string gateway ±24 KB untuk pemuat yang
 * meneruskan id lewat `.in()`). Jumlah di atas plafon dipulihkan sampai
 * plafonnya saja; jangkar yang tak termuat jatuh ke scrollY cadangan.
 */

/** Jumlah halaman maksimum yang dimuat ulang saat memulihkan satu daftar. */
export const LIST_RESTORE_MAX_PAGES = 10;

/**
 * Jumlah baris muatan pertama: `remembered` (jumlah termuat yang diingat; null
 * = tidak sedang memulihkan) dibulatkan ke atas ke kelipatan `pageSize`, lalu
 * dipagari satu halaman .. `maxPages` halaman. Nilai cacat → satu halaman.
 */
export function restoreLoadCount(
  remembered: number | null | undefined,
  pageSize: number,
  maxPages: number = LIST_RESTORE_MAX_PAGES
): number {
  const size = Number.isFinite(pageSize) && pageSize >= 1 ? Math.floor(pageSize) : 1;
  if (typeof remembered !== "number" || !Number.isFinite(remembered) || remembered <= size) {
    return size;
  }
  const pages = Math.ceil(remembered / size);
  const cap = Number.isFinite(maxPages) && maxPages >= 1 ? Math.floor(maxPages) : 1;
  return Math.min(pages, cap) * size;
}

/**
 * Pecah muatan `count` baris mulai `offset` menjadi permintaan berurutan yang
 * masing-masing ≤ `chunkMax` — untuk RPC yang membatasi `p_limit` (mis.
 * `search_public_products` memotong di 60).
 */
export function restoreChunks(
  count: number,
  chunkMax: number,
  offset: number = 0
): Array<{ offset: number; limit: number }> {
  const total = Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
  const step = Number.isFinite(chunkMax) && chunkMax >= 1 ? Math.floor(chunkMax) : 1;
  const start = Number.isFinite(offset) && offset > 0 ? Math.floor(offset) : 0;
  const chunks: Array<{ offset: number; limit: number }> = [];
  for (let done = 0; done < total; done += step) {
    chunks.push({ offset: start + done, limit: Math.min(step, total - done) });
  }
  return chunks;
}
